import { message } from 'antd';
import { put, takeLatest, call } from 'redux-saga/effects';
import { TaskSourceType } from 'api/tasks';
import { deleteTaskRecord, taskCollection } from 'collections/tasks';
import { getQueryClientContext } from 'data/core/sagas/query-client';
import { removeTask } from 'data/home/slice';
import { cleanupTaskDependenciesAndRemoveFromTimeline } from 'data/projects/sagas/project/timeline';
import { removeTaskFromSpaceTab } from 'data/space-tabs';
import { getProjectDependencyMapKey } from 'queries/common';
import { deleteTaskSagaAction } from '../actions';
function* deleteTaskByIdSaga({ payload }) {
    var _task_source;
    const { projectId, taskId, options } = payload;
    const task = taskCollection.get(taskId);
    const queryClient = yield getQueryClientContext();
    // 1) Clean Bryntum first (atomic + committed)
    yield call(cleanupTaskDependenciesAndRemoveFromTimeline, taskId);
    // 2) Now do Redux/UI changes (safe, engine and cache are consistent)
    if ((task === null || task === void 0 ? void 0 : (_task_source = task.source) === null || _task_source === void 0 ? void 0 : _task_source.sourceId) && task.source.sourceType === TaskSourceType.SpaceTab) {
        yield put(removeTaskFromSpaceTab({
            spaceTabId: task.source.sourceId,
            taskId
        }));
    }
    yield put(removeTask(taskId));
    if (!(options === null || options === void 0 ? void 0 : options.skipStoreUpdate)) {
        taskCollection.externalDelete(taskId);
    }
    // 3) Server + cache
    try {
        yield deleteTaskRecord(projectId, taskId, options === null || options === void 0 ? void 0 : options.actor);
        yield queryClient.invalidateQueries(getProjectDependencyMapKey(projectId));
    } catch (error) {
        message.error('There was an error processing your request.', error);
    }
}
export const watchDeleteTaskByIdSaga = function*() {
    yield takeLatest(deleteTaskSagaAction.type, deleteTaskByIdSaga);
};
